import React, { Component } from 'react';
import { Card, Button, Modal, Form, Row, Col, Spinner, Dropdown } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import "./index.css";
import { Link } from 'react-router-dom';
import { STATUS_CODE_TO_LABEL, TEMPLATES, USER_ROLES } from '../../../Helpers/constant.js';
import { TcdHeaderFormatter } from '../../../Helpers/tooltip.js';
import { switchUser } from '../../../Helpers/switchUser.js';

class ListHistoricalVoiceCampaignAdmin extends Component {
    constructor(props) {
        super(props);
        const isSadmin=props.app.role===USER_ROLES.S_ADMIN||props.app.role===USER_ROLES.SUB_SUPER_ADMIN;
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        this.state = {
            campaignlist: [],
            selectedCampaignId: 0,
            confirmStop: false,
            confirmPause: false,
            confirmResume: false,
            reloading: false,
            allSelected: false,
            retryOptionStates: {},
            apiRetryOptions: [],
            startDate: yesterday,
            endDate: yesterday,
            loading: true,
            sizePerPage: 10,
            selectedRows: [],
            moduleList: [],
            ttsFlag: false,
            showTable: false,
            continuousFlag: false,
            hasRetries: false,
            searchUserId: "",
            page: 1,
            totalSize: 0,
            filterBy : "",
            filterFlag : false,
            exportLoading: false,
            isWebhookModule:isSadmin,
			WebhookRetryModal:false,
            WebhookRetryCountModal:false,
            isSadmin:isSadmin
        }
    }

    componentDidMount() {
        const userId = this.props.app.userId;
        
        // Get User Module List
        Fetcher.get(this.props.app.apiPath + '/api/obd/module/list/' + userId)
            .then(res => {
                this.setState({ moduleList: res });
                if (!isEmpty(this.state.moduleList) && (!('error' in this.state.moduleList))) {
                    this.state.moduleList.map((fileObj) => {
                        if (fileObj.moduleName === 'TTS') {
                            this.setState({ ttsFlag: true });
                        }
                        if (fileObj.moduleName === 'Continuous Campaign') {
                            this.setState({ continuousFlag: true });
                        }
                    });
                }
            })
            .catch(err => console.log('Error in fetching Modules', err));

        const timer = setTimeout(() => {
            this.setState({ showTable: true });
        }, 2000);
        
        this.getCampaigns(1, this.state.sizePerPage);
        const savedSizePerPage = Cookies.get('histoVoicCampSum_S_P_P_Admin');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    getCampaigns = (page = 1, sizePerPage = 10, userId = null) => {
        const userIdReseller = this.props.app.userId;
		const userRole = this.props.app.role;
        const uId = userId || this.state.searchUserId;
        let sDate = this.state.startDate ? this.formatDate(this.state.startDate) : "";
        let eDate = this.state.endDate ? this.formatDate(this.state.endDate) : "";

        const data = {
            filterData : uId,
            uId : this.props.app.userId,
            startDate: sDate,
            endDate: eDate,
            pageSize: sizePerPage,
            pageNo: page,
            filterBy : this.state.filterBy,
        };

        if (userRole === 'ROLE_ADMIN') {
            data['userId'] = userIdReseller
            Fetcher.post(this.props.app.apiPath + '/api/obd/reseller/campaign/historical', {
                headers: { "Content-type": "application/json" },
                method: 'POST',
                body: JSON.stringify(data)
            })
                .then(res => {
                    const campaigns = res.response || [];
                    const total = res.totalRecords || 0;
                    const hasRetries = this.hasAnyRetries(campaigns);
                    this.setState({
                        campaignlist: campaigns,
                        totalSize: total,
                        confirmStop: false,
                        confirmPause: false,
                        confirmResume: false,
                        hasRetries: hasRetries,
                        page: page
                    });
                })
                .catch(err => console.log('Error in fetching Campaigns', err));

        } else {
            Fetcher.post(this.props.app.apiPath + '/api/obd/superadmin/campaign/historical', {
                headers: { "Content-type": "application/json" },
                method: 'POST',
                body: JSON.stringify(data)
            })
                .then(res => {
                    const campaigns = res.response || [];
                    const total = res.totalRecords || 0;
                    const hasRetries = this.hasAnyRetries(campaigns);
                    this.setState({
                        campaignlist: campaigns,
                        totalSize: total,
                        confirmStop: false,
                        confirmPause: false,
                        confirmResume: false,
                        hasRetries: hasRetries,
                        page: page
                    });
                })
                .catch(err => console.log('Error in fetching Campaigns', err));
        }
    }

    hasAnyRetries(campaigns) {
        if (Array.isArray(campaigns) && campaigns.length > 0) {
            for (let i = 0; i < campaigns.length; i++) {
                if (campaigns[i].retries > 0) {
                    return true;
                }
            }
        }
        return false;
    }

    refreshPage = () => {
        this.setState({ reloading: true });
        setTimeout(() => {
            window.location.reload(false);
        }, 500);
    }

    downloadReport = (index, campaignId, type) => {
        const data = {
            "campaignId": campaignId,
            "reprtType": type
        };
        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/download', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            alert(res.message);
            window.open(this.props.app.reportPath + '/reports/' + campaignId + '.zip', 'Download');
        })
        .catch(err => console.log('Error in Downloading Report', err));
    }

    generateReport = (index, campaignId, reportType) => {
        const userId = this.props.app.userId;
        const data = {
            "campaignId": campaignId,
            "reportType": reportType,
            "userId":userId
        };
        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            alert(res.message);
            this.getCampaigns(this.state.page, this.state.sizePerPage);
        })
        .catch(err => console.log('Error in Generating Report', err));
    }

    downloadPending = (index, campaignId) => {
        const data = {
            "campaignId": campaignId,
            "reportType": 'pending_data'
        };
        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/pending', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            let csvRows = res.map(item => item.substring(0, 10)).join('\n');
            const blob = new Blob([csvRows], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'pending_data_' + campaignId + '.csv';
            link.click();
        })
        .catch(err => {
            Notify.notify('Something went wrong');
            console.log('Error in Downloading Report', err);
        });
    }

    confirmStop = (status, campaignId) => {
        this.setState({
            confirmStop: status,
            selectedCampaignId: campaignId
        });
    }

    confirmPause = (status, campaignId) => {
        this.setState({
            confirmPause: status,
            selectedCampaignId: campaignId
        });
    }

    confirmResume = (status, campaignId) => {
        this.setState({
            confirmResume: status,
            selectedCampaignId: campaignId
        });
    }

    stopCampaign = () => {
        const campaignId = this.state.selectedCampaignId;
        const data = { campaignId: campaignId };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/stop', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            Notify.notify(res.message);
            this.getCampaigns(this.state.page, this.state.sizePerPage);
        })
        .catch(err => console.log('Error in Stopping', err));
    }

    bulkGenerateReport = () => {
        const userId = this.props.app.userId;
        const idsToFind = this.state.selectedRows;
        const filteredRecords = this.state.campaignlist.filter(record => idsToFind.includes(record.campaignId));
        const totalCallSum = filteredRecords.reduce((sum, record) => sum + record.numbersUploaded, 0);

        if (totalCallSum > 1000000) {
            Notify.notify('Total Numbers Limit cannot exceed 10 Lakhs.');
            this.setState({ reloading: true });
            setTimeout(() => window.location.reload(false), 2500);
            return;
        }

        const data = {
            "campaignId": 0,
            "reportType": "bulk",
            "campaignIds": this.state.selectedRows.toString(),
            "userId":userId
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            Notify.notify(res.message);
            this.setState({ reloading: true });
            setTimeout(() => window.location.reload(false), 2500);
        })
        .catch(err => console.log('Error in Generating Report', err));
    }

    retryWebhook = () => {
        this.setState({ loading: true });
        const campaignId = this.state.selectedCampaignId;
        const data = {
            campaignId: campaignId,
        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/retry/failed/webhook', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
            .then(res => {
                Notify.notify(res.message);
                this.getCampaigns(this.state.page, this.state.sizePerPage);

            })
            .catch(err => {
                console.log('Error in Retry', err);
                // this.setState({ loading: false });
            }).finally(() => this.setState({ loading: false, selectedCampaignId: "", WebhookRetryModal: false }));

    }
    
    retryWebhookCount = () => {
        this.setState({ loading: true });
        const campaignId = this.state.selectedCampaignId;
        const data = {
            campaignId: campaignId,
        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/reset/retry/failed/webhook', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
            .then(res => {
                Notify.notify(res.message);
               this.getCampaigns(this.state.page, this.state.sizePerPage);

            })
            .catch(err => {
                console.log('Error in webhook Retry count', err);
                // this.setState({ loading: false });
            }).finally(() => this.setState({ loading: false, selectedCampaignId: "", WebhookRetryCountModal: false }));
    }

    pauseCampaign = () => {
        const campaignId = this.state.selectedCampaignId;
        const data = { campaignId: campaignId };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/pause', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            Notify.notify(res.message);
            this.getCampaigns(this.state.page, this.state.sizePerPage);
        })
        .catch(err => console.log('Error in Pause', err));
    }
    
    resumeCampaign = () => {
        const campaignId = this.state.selectedCampaignId;
        const data = {
            campaignId: campaignId,
            userId: this.props.app.userId
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/resume', { 
            headers: { "Content-type": "application/json" }, 
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(res => {
            Notify.notify(res.message);
            this.getCampaigns(this.state.page, this.state.sizePerPage);
        })
        .catch(err => console.log('Error in Resume', err));
    }

    hasSelectedRunningCampaigns = () => {
        const { selectedRows, campaignlist } = this.state;
        return selectedRows.some(campaignId => {
            const campaign = campaignlist.find(c => c.campaignId === campaignId);
            return campaign && campaign.campaignStatus === 1;
        });
    }

    bulkSystemAction = (status) => {
        const { selectedRows } = this.state;

        const data = {
            campaignIds: selectedRows.join(','),
            status: status
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/status/change', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.error) return
                const statusText = status === 12 ? 'Cancelled' : 'Completed';
                Notify.notify(res.message ?? `Campaigns successfully marked as ${statusText}`);
                this.getCampaigns();
                this.setState({ selectedRows: [] });
            })
            .catch(err => {
                console.log('Error in bulk system action', err);
                Notify.notify('Error updating campaigns');
            });
    }

    handleSystemCancel = () => {
        this.bulkSystemAction(12); // Status 12 for Cancel
    }

    handleSystemComplete = () => {
        this.bulkSystemAction(11); // Status 11 for Complete
    }

    handleStartDateChange = (date) => {
        this.setState({ startDate: date });
    };

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    };
    setvalue = (e) => {
        this.setState({
          [e.target.name]: e.target.value,
        });

        if(this.state.filterBy!=""){
            this.setState({ filterFlag : true });
        }
    }

    setvalue = (e) => {
        this.setState({
          [e.target.name]: e.target.value,
        });

        if(this.state.filterBy!=""){
            this.setState({ filterFlag : true });
        }
    }

    handleUserIdChange = (e) => {
        this.setState({ searchUserId: e.target.value });
    };

    handleTableChange = (type, { page, sizePerPage }) => {
        if (type === 'pagination') {
            this.getCampaigns(page, sizePerPage);
        }
    }

    formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    searchCdr = async (e) => {
        e.preventDefault();
        // Reset to first page and fetch campaigns
        this.getCampaigns(1, this.state.sizePerPage);
    }

    toggleCheckedChange = (e, optionName) => {
        const { checked } = e.target;
        if (optionName === 'All') {
            const updatedOptionStates = {};
            Object.keys(this.state.retryOptionStates).forEach((key) => {
                updatedOptionStates[key] = checked;
            });
            this.setState({
                allSelected: checked,
                retryOptionStates: updatedOptionStates,
            });
        } else {
            this.setState((prevState) => ({
                retryOptionStates: {
                    ...prevState.retryOptionStates,
                    [optionName]: checked,
                },
            }));
        }
    };

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('histoVoicCampSum_S_P_P_Admin', newSizePerPage);
    }

    handleSelectAll = (isSelect) => {
        const { campaignlist } = this.state;
        if (isSelect) {
            this.setState({ selectedRows: campaignlist.map(p => p.campaignId) });
        } else {
            this.setState({ selectedRows: [] });
        }
    };

    handleSelectRow = (row, isSelect) => {
        this.setState(prevState => {
            const selectedRows = [...prevState.selectedRows];
            if (isSelect) {
                selectedRows.push(row.campaignId);
            } else {
                const index = selectedRows.indexOf(row.campaignId);
                if (index > -1) {
                    selectedRows.splice(index, 1);
                }
            }
            return { selectedRows };
        });
    };

    isSelectedAll = () => {
        const { campaignlist, selectedRows } = this.state;
        return selectedRows.length === campaignlist.length;
    };

    getAllCampaignsForExport = async () => {
        const { startDate, endDate } = this.state;
        
        if (!startDate || !endDate) {
            Notify.notify('Please select both start and end dates');
            return null;
        }
        
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 7) {
            Notify.notify('Maximum export period is one week');
            return null;
        }
        
        this.setState({ exportLoading: true });
        
        try {
            const uId = this.state.searchUserId;
            let sDate = this.formatDate(startDate);
            let eDate = this.formatDate(endDate);
            
            const data = {
                filterData: uId,
                startDate: sDate,
                endDate: eDate,
                pageSize: this.state.totalSize, 
                pageNo: 1,
                filterBy: this.state.filterBy,

            };
            
            let endpoint = "";
            const userRole = this.props.app.role;
            if (userRole === 'ROLE_ADMIN'){
                const userIdReseller = this.props.app.userId;
                data['userId'] = userIdReseller
                endpoint = "/reseller/campaign/historical";
            }else{
                endpoint = "/superadmin/campaign/historical"
            }

            const res = await Fetcher.post(this.props.app.apiPath + '/api/obd'+endpoint, {
                headers: { "Content-type": "application/json" },
                method: 'POST',
                body: JSON.stringify(data)
            });
            
            const campaigns = res.response || [];
            this.setState({ allCampaigns: campaigns, exportLoading: false });
            return campaigns;
        } catch (err) {
            console.log('Error in fetching all campaigns', err);
            Notify.notify('Error fetching data for export');
            this.setState({ exportLoading: false });
            return null;
        }
    };

    mapCampaignsToProducts=(campaigns)=>{
        if(!Array.isArray(campaigns)){
            return [];
        }
        return campaigns.map((campaign, index) => {
            const template = TEMPLATES[campaign.templateId] ?? ""
			const status = STATUS_CODE_TO_LABEL[campaign.campaignStatus] ?? '';
            
            let action = [];
            
            action.push(
                <Dropdown id="dd">
                    <Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
                    <Dropdown.Menu style={{ width: 'max-content' }}>
                        {campaign.campaignStatus === 1 && 
                            <Dropdown.Item key={`ps-campaign-${index}`} onClick={() => this.confirmPause(true, campaign.campaignId)} href="#">
                                Pause Campaign
                            </Dropdown.Item>
                        }
                        {campaign.campaignStatus === 9 && 
                            <Dropdown.Item key={`rs-campaign-${index}`} onClick={() => this.confirmResume(true, campaign.campaignId)} href="#">
                                Resume Campaign
                            </Dropdown.Item>
                        }
                        {campaign.campaignStatus === 1 && 
                            <Dropdown.Item key={`st-campaign-${index}`} onClick={() => this.confirmStop(true, campaign.campaignId)} href="#">
                                Stop Campaign
                            </Dropdown.Item>
                        }
                        {(campaign.fullReportStatus === '2' || campaign.fullRreportStatus === undefined) && 
                            <Dropdown.Item id={`greport-${index}`} key={`greport-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'full')} href="#">
                                Generate Full Report
                            </Dropdown.Item>
                        }
                        {campaign.webhookLog === '1' && 
                            <Dropdown.Item id={`greport-webhook-${index}`} key={`greport-webhook-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'webhook')} href="#">
                                Generate Webhook Report
                            </Dropdown.Item>
                        }
                    </Dropdown.Menu>
                </Dropdown>
            );
            
            let callsSubmitted = 0;
            let dtmfDownload = [];
            dtmfDownload.push(campaign.dtmfCount);
            dtmfDownload.push(' ');
            
            if (campaign.templateId === 1 || campaign.templateId === 2 || campaign.templateId === 3) {
                if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
                    dtmfDownload.push(
                        <a data-tip="" key={`${index}-dtmf`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf') }} href="#">
                            <i className="fa fa-download"></i>
                        </a>
                    );
                }
            }
            
            let dtmf1Download = [];
            dtmf1Download.push(campaign.dtmf1Count);
            dtmf1Download.push(' ');
            
            if (campaign.templateId === 3) {
                if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
                    dtmf1Download.push(
                        <a data-tip="" key={`${index}-dtmf1`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf1') }} href="#">
                            <i className="fa fa-download"></i>
                        </a>
                    );
                }
            }
            
            let dtmf2Download = [];
            dtmf2Download.push(campaign.dtmf2Count);
            dtmf2Download.push(' ');
            
            if (campaign.templateId === 3) {
                if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
                    dtmf2Download.push(
                        <a data-tip="" key={`${index}-dtmf2`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf2') }} href="#">
                            <i className="fa fa-download"></i>
                        </a>
                    );
                }
            }
            
            let ccDownload = [];
            ccDownload.push(campaign.callsConnected);
            ccDownload.push(' ');
            
            if (campaign.callsConnected > 0) {
                if (campaign.ccReportStatus === '2' || campaign.ccReportStatus === undefined) {
                    ccDownload.push(
                        <a data-tip="" key={`${index}-cc`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'connected_calls') }} href="#">
                            <i className="fa fa-download"></i>
                        </a>
                    );
                }
            }
            
            let ccPending = [];
            ccPending.push(campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed);
            ccDownload.push(' ');
            ccPending.push(
                <a data-tip="" key={`${index}-pending`} className="download-report" onClick={(e) => { this.downloadPending(true, campaign.campaignId) }} href="#">
                    <i className="fa fa-download"></i>
                </a>
            );
    
            let smsDownload = [];
            smsDownload.push(campaign.smsCount);
            smsDownload.push(' ');
            
            if (campaign.smsCount > 0) {
                if (campaign.smsStatus == 2 || campaign.smsStatus == undefined) {
                    smsDownload.push(
                        <a data-tip="" key={`${index}-sms`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'sms') }} href="#">
                            <i className="fa fa-download"></i>
                        </a>
                    );
                }
            }

            let webhookFailedCount =  Number(campaign.webhookFailedCount) || 0;
            let retryWebhookCount= Number(campaign.retryWebhookCount) || 0;
								// console.log({webhookFailedCount})

			if (webhookFailedCount > 0) {
				const currentDate = new Date();
				const scheduleDate = new Date(
					campaign.scheduleTime.replace(" ", "T")
				);
				const diffTime = currentDate - scheduleDate;
				const diffDays = Math.floor(
					(diffTime) / (1000 * 60 * 60 * 24)
				);
				// console.log({diffDays,scheduleTime:campaign.scheduleTime})
				if (diffDays <= 2 && retryWebhookCount <= 2) {
					webhookFailedCount = <span key={`${index}-retry-cm`}  >{webhookFailedCount}<a href="#" className="download-report" style={{margin:"4px"}} onClick={() => { this.setState({ selectedCampaignId: campaign.campaignId, WebhookRetryModal: true }) }}><i className="fa fa-repeat"></i></a></span>
				}
			}
            if (retryWebhookCount === 2) {
				retryWebhookCount = <span key={`${index}-retry-webhook-cm`}  >{retryWebhookCount}<a href="#" className="download-report" style={{ margin: "4px" }} onClick={() => { this.setState({ selectedCampaignId: campaign.campaignId, WebhookRetryCountModal: true }) }}><i className="fa fa-cog"></i></a></span>
			}
            return {
                id: index + 1,
                campaignId: campaign.campaignId,
                userId: campaign.userId,
                name: campaign.campaignName,
                campaignName: ([0,1,2,3,7,8,9].includes(campaign.templateId)) ? 
                    <Link key={`${index}-cm`} to={`${this.props.app.urlPrefix}/voice-campaign-info/${campaign.campaignId}`}>{campaign.campaignName}</Link> : 
                    campaign.campaignName,
                campaignstatus: status,
                templateId: template,
                scheduleTime: campaign.scheduleTime,
                endTime: campaign.endTime,
                pauseTime: campaign.pauseTime,
                numbersUploaded: campaign.numbersUploaded,
                numbersProcessed: campaign.numbersProcessed,
                callsSubmitted: (campaign.campaignStatus === 7) ? ccPending : campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
                callsSubmittedCsv: campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
                callsConnected: (campaign.campaignStatus === 2) ? ccDownload : campaign.callsConnected,
                callsConnectedCsv: campaign.callsConnected,
                pulses: campaign.pulses,
                dndCount: campaign.dndCount,
                dtmfCount: (campaign.campaignStatus === 2) ? dtmfDownload : campaign.dtmfCount,
                dtmf1Count: (campaign.campaignStatus === 2) ? dtmf1Download : campaign.dtmf1Count,
                dtmf2Count: (campaign.campaignStatus === 2) ? dtmf2Download : campaign.dtmf2Count,
                dtmfCountCsv: campaign.dtmfCount,
                dtmf1CountCsv: campaign.dtmf1Count,
                dtmf2CountCsv: campaign.dtmf2Count,
                smsCount: (campaign.campaignStatus === 2) ? smsDownload : campaign.smsCount,
                retryCount: campaign.retryCount,
                retries: campaign.retries,
                fullReportStatus: action,
                ttsCount: campaign.ttsCount,
                smsCount1: campaign.smsCount,
                failedCount: campaign.failedCount || 0,
                totalCallsDialed: (campaign.numbersProcessed + (campaign.retryCount || 0)),
                webhookSuccessCount:(campaign.webhookSuccessCount??0),
				webhookLog:(campaign.webhookLog??0),
				webhookFailedCount:webhookFailedCount,
				retryWebhookCount:retryWebhookCount,
				retryWebhookCountOriginal:campaign.retryWebhookCount,
                webhookFailedCountCsv:Number(campaign.webhookFailedCount) || 0,
                username: campaign.username ?? ""
            };
        })
    }

    switchToUser = (userId) => {
        Fetcher.post(this.props.app.apiPath + "/api/obd/switch/user", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId: userId }),
        })
            .then((res) => {
                switchUser(res.userid, res.token, res.role);
                if (res.role.includes('ROLE_SUSER')) {
                    window.location.href = "/sub-user-report";
                } else {
                    window.location.href = "/";
                }
                Notify.notify('User Switch Successfully');
            })
            .catch((err) => {
                console.error("Error while switching user", err);
                Notify.notify("Error while switching user");
            });
    }

    handleExport = async (onExport) => {
        const campaigns = await this.getAllCampaignsForExport();
        if (campaigns) {
            const products = this.mapCampaignsToProducts(campaigns);
            onExport(products);
        }
    };
    render() {
        const campaigns = this.state.campaignlist;
        let columns = [];

        if (this.state.ttsFlag === true) {
            columns = [
                {
                    dataField: 'select',
                    text: 'Select',
                    csvExport: false,
                    headerRenderer: () => (
                        <input
                            type="checkbox"
                            checked={this.isSelectedAll()}
                            onChange={(e) => this.handleSelectAll(e.target.checked)}
                            style={{ margin: '0 auto', display: 'block' }}
                        />
                    ),
                    formatter: (cell, row) => (
                        <input 
                            type="checkbox" 
                            checked={this.state.selectedRows.includes(row.campaignId)}
                            onChange={(e) => this.handleSelectRow(row, e.target.checked)} 
                        />
                    ),
                    headerStyle: { width: '50px', textAlign: 'center' },
                },
                {
                    dataField: 'id',
                    text: 'Serial No.',
                    sort: false,
                    hidden: true
                },
                {
                    dataField: 'campaignId',
                    text: 'Campaign ID',
                    sort: false,
                    hidden: false
                },
                {
                    dataField: 'campaignName',
                    text: 'Campaign Name',
                    sort: true,
                    searchable: true,
                    csvExport: false,
                    style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' }
                }, 
                 {
                    dataField: 'username',
                    text: 'User Name',
                    sort: true,
                    searchable: true,
                    csvExport: true,
                    style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' },
                    formatter: (cell, row) => (
                        <span>
                            {cell}
                            {this.props.app.role === 'ROLE_SADMIN' && (
                                <img
                                    src="/assets/switch-user.png"
                                    alt="Switch User"
                                    title="Switch to this user"
                                    style={{ width: "20px", height: "20px", cursor: "pointer", marginLeft: "6px" }}
                                    onClick={() => this.switchToUser(row.userId)}
                                />
                            )}
                        </span>
                    )
                },
                {
                    dataField: 'userId',
                    text: 'User Id',
                    sort: true,
                    searchable: true,
                    hidden: true,
                    csvExport: true
                }, 
                {
                    dataField: 'name',
                    text: 'Campaign Name',
                    sort: true,
                    searchable: true,
                    hidden: true,
                    csvExport: true
                }, 
                {
                    dataField: 'campaignstatus',
                    text: 'Campaign Status',
                    sort: true,
                    searchable: true
                }, 
                {
                    dataField: 'templateId',
                    text: 'Campaign Type',
                    sort: true,
                    searchable: true
                },
                {
                    dataField: 'scheduleTime',
                    text: 'Start Time',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'endTime',
                    text: 'End Time',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'pauseTime',
                    text: 'Pause Time',
                    sort: true,
                    searchable: false
			    }, 
                {
                    dataField: 'numbersUploaded',
                    text: 'Total Numbers',
                    sort: false,
                    searchable: false
                }, {
                    dataField: 'totalCallsDialed',
                    text: 'TCD',
                    headerFormatter: () => (
                        <TcdHeaderFormatter
                            id="tcd-tooltip"
                            text="TCD"
                            tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
                        />),
                    sort: false,
                    searchable: false,
                    headerStyle: { minWidth: "90" }
                }, 
                {
                    dataField: 'numbersProcessed',
                    text: 'Calls Dialed',
                    sort: false,
                    searchable: false
                }, 
                {
                    dataField: 'callsSubmitted',
                    text: 'Pending Calls',
                    sort: false,
                    searchable: false,
                    csvExport: false,
                    hidden: this.state.continuousFlag
                },
                {
                    dataField: 'callsSubmittedCsv',
                    text: 'Pending Calls',
                    sort: false,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'failedCount',
                    text: 'Failed Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.continuousFlag,
                    csvExport: this.state.continuousFlag
                },
                {
                    dataField: 'callsConnected',
                    text: 'Connected Calls',
                    sort: false,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'callsConnectedCsv',
                    text: 'Connected Calls',
                    sort: false,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'pulses',
                    text: 'Total Pulses',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'dndCount',
                    text: 'DnD Count',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'dtmfCount',
                    text: 'Dtmf Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmf1Count',
                    text: 'Dtmf1 Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmf2Count',
                    text: 'Dtmf2 Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmfCountCsv',
                    text: 'Dtmf Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'dtmf1CountCsv',
                    text: 'Dtmf1 Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'dtmf2CountCsv',
                    text: 'Dtmf2 Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'webhookFailedCount',
                    text: 'Webhook Failed Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: false
                },{
                    dataField: 'webhookFailedCountCsv',
                    text: 'Webhook Failed Count',
                    hidden: true,
                    csvExport: this.state.isWebhookModule
			    },{
                    dataField: 'webhookLog',
                    text: 'Webhook Log',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: this.state.isWebhookModule
                },{
                    dataField: 'webhookSuccessCount',
                    text: 'Webhook Success Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: this.state.isWebhookModule
                },{
                    dataField: 'retryWebhookCountOriginal',
                    text: 'Webhook Retry Count',
                    hidden: true,
                    csvExport: this.state.isWebhookModule
                },
                {
                    dataField: 'retryWebhookCount',
                    text: 'Webhook Retry Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: false
                },{
                    dataField: 'smsCount',
                    text: 'SMS Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'smsCount1',
                    text: 'SMS Count',
                    sort: true,
                    searchable: false,
                    csvExport: true,
                    hidden: true
                },
                {
                    dataField: 'retryCount',
                    text: 'Retry Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.hasRetries,
                    csvExport: this.state.hasRetries
                },
                {
                    dataField: 'retries',
                    text: 'Is Retry',
                    sort: true,
                    searchable: false,
                    hidden: true
                },
                {
                    dataField: 'ttsCount',
                    text: 'Total Variable Count',
                    sort: false,
                    hidden: false,
                    csvExport: true
                },
                {
                    dataField: 'retries',
                    text: 'No. Of retries',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.hasRetries,
                    csvExport: this.state.hasRetries
                },
                {
                    dataField: 'fullReportStatus',
                    text: 'Action',
                    sort: false,
                    searchable: false,
                    csvExport: false
                }
            ];
        } else {
            columns = [
                {
                    dataField: 'select',
                    text: 'Select',
                    csvExport: false,
                    headerRenderer: () => (
                        <input
                            type="checkbox"
                            checked={this.isSelectedAll()}
                            onChange={(e) => this.handleSelectAll(e.target.checked)}
                            style={{ margin: '0 auto', display: 'block' }}
                        />
                    ),
                    formatter: (cell, row) => (
                        <input 
                            type="checkbox" 
                            checked={this.state.selectedRows.includes(row.campaignId)}
                            onChange={(e) => this.handleSelectRow(row, e.target.checked)} 
                        />
                    ),
                    headerStyle: { width: '50px', textAlign: 'center' },
                },
                {
                    dataField: 'id',
                    text: 'Serial No.',
                    sort: false,
                    hidden: true
                },
                {
                    dataField: 'campaignId',
                    text: 'Campaign ID',
                    sort: false,
                    hidden: false
                },
                {
                    dataField: 'campaignName',
                    text: 'Campaign Name',
                    sort: true,
                    searchable: true,
                    csvExport: false,
                    style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' }
                }, 
                {
                    dataField: 'username',
                    text: 'User Name',
                    sort: true,
                    searchable: true,
                    csvExport: true,
                    style: { maxWidth:"288px", whiteSpace: 'normal', wordWrap: 'break-word' },
                    formatter: (cell, row) => (
                        <span>
                            {cell}
                            {this.props.app.role === 'ROLE_SADMIN' && (
                                <img
                                    src="/assets/switch-user.png"
                                    alt="Switch User"
                                    title="Switch to this user"
                                    style={{ width: "20px", height: "20px", cursor: "pointer", marginLeft: "6px" }}
                                    onClick={() => this.switchToUser(row.userId)}
                                />
                            )}
                        </span>
                    )
                },
                {
                    dataField: 'userId',
                    text: 'User Id',
                    sort: true,
                    searchable: true,
                    hidden: true,
                    csvExport: true
                }, 
                {
                    dataField: 'name',
                    text: 'Campaign Name',
                    sort: true,
                    searchable: true,
                    hidden: true,
                    csvExport: true
                }, 
                {
                    dataField: 'campaignstatus',
                    text: 'Campaign Status',
                    sort: true,
                    searchable: true
                }, 
                {
                    dataField: 'templateId',
                    text: 'Campaign Type',
                    sort: true,
                    searchable: true
                },
                {
                    dataField: 'scheduleTime',
                    text: 'Start Time',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'endTime',
                    text: 'End Time',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'pauseTime',
                    text: 'Pause Time',
                    sort: true,
                    searchable: false
			    }, 
                {
                    dataField: 'numbersUploaded',
                    text: 'Total Numbers',
                    sort: false,
                    searchable: false
                }, {
                    dataField: 'totalCallsDialed',
                    text: 'TCD',
                    headerFormatter: () => (
                        <TcdHeaderFormatter
                            id="tcd-tooltip"
                            text="TCD"
                            tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
                        />),
                    sort: false,
                    searchable: false,
                    headerStyle: { minWidth: "90px" }
                }, 
                {
                    dataField: 'numbersProcessed',
                    text: 'Calls Dialed',
                    sort: false,
                    searchable: false
                }, 
                {
                    dataField: 'callsSubmitted',
                    text: 'Pending Calls',
                    sort: false,
                    searchable: false,
                    csvExport: false,
                    hidden: this.state.continuousFlag
                },
                {
                    dataField: 'failedCount',
                    text: 'Failed Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.continuousFlag,
                    csvExport: this.state.continuousFlag
                },
                {
                    dataField: 'callsSubmittedCsv',
                    text: 'Pending Calls',
                    sort: false,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'callsConnected',
                    text: 'Connected Calls',
                    sort: false,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'callsConnectedCsv',
                    text: 'Connected Calls',
                    sort: false,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'pulses',
                    text: 'Total Pulses',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'dndCount',
                    text: 'DnD Count',
                    sort: true,
                    searchable: false
                },
                {
                    dataField: 'dtmfCount',
                    text: 'Dtmf Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmf1Count',
                    text: 'Dtmf1 Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmf2Count',
                    text: 'Dtmf2 Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'dtmfCountCsv',
                    text: 'Dtmf Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'dtmf1CountCsv',
                    text: 'Dtmf1 Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'dtmf2CountCsv',
                    text: 'Dtmf2 Count',
                    sort: true,
                    searchable: false,
                    hidden: true,
                    csvExport: true
                },
                {
                    dataField: 'webhookFailedCount',
                    text: 'Webhook Failed Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: false
                },{
                    dataField: 'webhookFailedCountCsv',
                    text: 'Webhook Failed Count',
                    hidden: true,
                    csvExport: this.state.isWebhookModule
			    },{
                    dataField: 'webhookLog',
                    text: 'Webhook Log',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: this.state.isWebhookModule
                },{
                    dataField: 'webhookSuccessCount',
                    text: 'Webhook Success Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: this.state.isWebhookModule
                },{
                    dataField: 'retryWebhookCountOriginal',
                    text: 'Webhook Retry Count',
                    hidden: true,
                    csvExport: this.state.isWebhookModule
                },{
                    dataField: 'retryWebhookCount',
                    text: 'Webhook Retry Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.isWebhookModule,
                    csvExport: false
                },{
                    dataField: 'smsCount',
                    text: 'SMS Count',
                    sort: true,
                    searchable: false,
                    csvExport: false
                },
                {
                    dataField: 'smsCount1',
                    text: 'SMS Count',
                    sort: true,
                    searchable: false,
                    csvExport: true,
                    hidden: true
                },
                {
                    dataField: 'retryCount',
                    text: 'Retry Count',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.hasRetries,
                    csvExport: this.state.hasRetries
                },
                {
                    dataField: 'retries',
                    text: 'Is Retry',
                    sort: true,
                    searchable: false,
                    hidden: true
                },
                {
                    dataField: 'ttsCount',
                    text: 'Total Variable Count',
                    sort: false,
                    hidden: false,
                    csvExport: true
                },
                {
                    dataField: 'retries',
                    text: 'No. Of retries',
                    sort: true,
                    searchable: false,
                    hidden: !this.state.hasRetries,
                    csvExport: this.state.hasRetries
                },
                {
                    dataField: 'fullReportStatus',
                    text: 'Action',
                    sort: false,
                    searchable: false,
                    csvExport: false
                }
            ];
        }

        const products = Array.isArray(campaigns) ? this.mapCampaignsToProducts(campaigns) : [];

        const { SearchBar, ClearSearchButton } = Search;
        const { ExportCSVButton } = CSVExport;

        const defaultSorted = [{
            dataField: 'scheduleTime',
            order: 'desc'
        }];

        // Set max date to yesterday
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() - 1);

        const paginationOption = {
            custom: true,
            totalSize: this.state.totalSize,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            page: this.state.page,
            onSizePerPageChange: (sizePerPage, page) => {
                this.setState({ sizePerPage: sizePerPage }, () => {
                    this.getCampaigns(page, sizePerPage);
                });
                Cookies.set('histoVoicCampSum_S_P_P_Admin', sizePerPage);
            }
        };
        const Options = {
            "user_id": "User Id",
            "campaign_id": "Campaign Id",
            "campaign_name": "Campaign Name"
        }
        return (
            <Card>
                <Card.Header>Historical Voice Campaign Summary Admin</Card.Header>
                <Card.Body>
                    <div className="campaign-list-table-cont">
                        <Form className="add-campaign-form" method='post' onSubmit={(e) => this.searchCdr(e)}> 
                             <Row>
                                <Col sm={2}>
                                    <Form.Group className="form-group col-md-12 float-left" style={{ paddingLeft: 0 }}>
                                        <DatePicker
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd"
                                            selected={this.state.startDate}
                                            onChange={this.handleStartDateChange}
                                            placeholderText="Start Date"
                                            maxDate={maxDate}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Form.Group className="form-group col-md-12 float-left" style={{ paddingLeft: 0 }}>
                                        <DatePicker
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd"
                                            selected={this.state.endDate}
                                            onChange={this.handleEndDateChange}
                                            placeholderText="End Date"
                                            maxDate={maxDate}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col sm={3}>
                                    <Form.Group className="form-group required control-label">
                                        <Form.Select className="dd" name="filterBy" value={this.state.filterBy} onChange={e => this.setvalue(e)} as="select">
                                            <option value="">Select Filter</option>
                                            {Object.entries(Options).map(([key, label]) => (
                                                <option key={key} value={key}>
                                                    {label}
                                                </option>
                                            ))}

                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {this.state.filterBy!="" && 
                                <Col sm={2}>
                                    <Form.Group  className="form-group col-md-12 float-left" style={{ paddingLeft: 0 }}>
                                        <Form.Control required
                                            type="text"
                                            value={this.state.searchUserId}
                                            onChange={this.handleUserIdChange}
                                            placeholder={Options[this.state.filterBy]} 
                                        />
                                    </Form.Group>
                                </Col>

                               }
                                <Col sm={1}>
                                    <Button variant="primary" type="submit">Search</Button>
                                </Col>

                                {/* Buttons at the end */}
                                <Col className="ms-auto text-end">
                                    {this.state.selectedRows.length > 0 && !this.hasSelectedRunningCampaigns() && (
                                        <>
                                            <Button
                                                variant="primary"
                                                className="me-2"
                                                onClick={this.handleSystemCancel}
                                            >
                                                System Cancel
                                            </Button>
                                            <Button
                                                variant="primary"
                                                onClick={this.handleSystemComplete}
                                            >
                                                System Complete
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </Form> 
                        
                        {this.state.showTable ? (
                            <PaginationProvider pagination={paginationFactory(paginationOption)}>
                                {({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <ToolkitProvider 
                                        keyField="id" 
                                        data={products} 
                                        columns={columns} 
                                        search 
                                        bootstrap4
                                        exportCSV={{ fileName: 'historical_campaign_summary.csv' }}
                                    >
                                        {props => (
                                            <div className="">
                                                Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                                {/* <ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton> */}
                                                <ExportCSVButton 
                                                    className="export-csv btn-primary ml-2" 
                                                    {...props.csvProps}
                                                    onClick={() => this.handleExport(props.csvProps.onExport)}
                                                    disabled={this.state.exportLoading}
                                                >
                                                    {this.state.exportLoading ? (
                                                        <>
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                            {' Exporting...'}
                                                        </>
                                                    ) : (
                                                        'Export All Data'
                                                    )}
                                                </ExportCSVButton>
                                                <Button 
                                                    type="button" 
                                                    className="float-right btn btn-default btn-primary ml-2" 
                                                    onClick={() => this.refreshPage()}
                                                >
                                                    Refresh
                                                </Button>
                                                {this.state.selectedRows.length > 0 && (
                                                    <Button 
                                                        type="button" 
                                                        className="float-right btn btn-default btn-primary ml-2" 
                                                        onClick={() => this.bulkGenerateReport()}
                                                    >
                                                        Generate Bulk Report
                                                    </Button>
                                                )}
                                                <hr/>
                                                <BootstrapTable 
                                                    remote
                                                    bordered={true} 
                                                    hover 
                                                    defaultSorted={defaultSorted} 
                                                    wrapperClasses="table-responsive" 
                                                    classes="w-auto campaignlist-table" 
                                                    {...props.baseProps} 
                                                    {...paginationTableProps} 
                                                    onTableChange={this.handleTableChange}
                                                    noDataIndication={() => this.state.reloading ? <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div> : <div>No data available</div>}
                                                />
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        )}
                                    </ToolkitProvider>
                                )}
                            </PaginationProvider>
                        ) : (
                            <div className="loader">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        )}
                    </div>
                    
                    {/* Modals */}
                    <Modal size="md" show={this.state.confirmStop} onHide={() => this.confirmStop(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title>Stop Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to stop this campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmStop(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.stopCampaign} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>
                    
                    <Modal size="md" show={this.state.WebhookRetryModal} onHide={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Rerty Webhook Campaign
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to retry webhook for this campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })} variant="secondary">CANCEL</Button>
                            <Button onClick={this.retryWebhook} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal size="md" show={this.state.WebhookRetryCountModal} onHide={() => this.setState({ selectedCampaignId: "", WebhookRetryCountModal: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Reset Webhook Count
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to reset webhook rerty count for this campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.setState({ selectedCampaignId: "", WebhookRetryCountModal: false })} variant="secondary">CANCEL</Button>
                            <Button onClick={this.retryWebhookCount} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal size="md" show={this.state.confirmPause} onHide={() => this.confirmPause(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title>Pause Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to pause this campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmPause(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.pauseCampaign} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.confirmResume} onHide={() => this.confirmResume(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title>Resume Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to resume this campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmResume(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.resumeCampaign} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>

                </Card.Body>
            </Card>
        );
    }
}

export default ListHistoricalVoiceCampaignAdmin;